import { motion } from "framer-motion";
import { Sparkle } from "@phosphor-icons/react";

const ACTIVITIES = [
  "Sports", "Mock Assembly", "Seminars", "Daily Examination", "Open House Activities",
  "Group Discussion", "Charity Activities", "Handwriting Skills", "Respect Forefathers",
  "Discipline", "Nationality", "Moral Values", "Every day is a new day",
];

const COLORS = ["bg-blue-50 text-blue-800", "bg-amber-50 text-amber-800", "bg-emerald-50 text-emerald-800",
  "bg-pink-50 text-pink-800", "bg-violet-50 text-violet-800", "bg-teal-50 text-teal-800"];

export const Activities = () => (
  <section id="activities" className="py-20 px-4 scroll-mt-24" data-testid="activities-section">
    <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="flex justify-center">
        <img src="/site/activities-poster.jpg" alt="Every Activity Builds a Better Student — St. Thomas (Altitude) High School"
          className="w-full max-w-md rounded-2xl shadow-xl border border-zinc-200" data-testid="activities-poster" />
      </motion.div>
      <div>
        <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#E39A0B]">Beyond the Classroom</div>
        <h2 className="font-display text-3xl md:text-4xl font-black text-[#0B2A5C] mt-2">Every Activity Builds a Better Student.</h2>
        <p className="text-zinc-700 mt-4 leading-relaxed">
          From the morning assembly to the sports field, every day at St. Thomas (Altitude) High School is filled with
          activities that shape knowledge, discipline and character.
        </p>
        <div className="flex flex-wrap gap-2 mt-6">
          {ACTIVITIES.map((a, i) => (
            <span key={a} className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold ${COLORS[i % COLORS.length]}`}
              data-testid={`activity-chip-${i}`}>
              <Sparkle size={14} weight="fill" /> {a}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);
